// extracted by mini-css-extract-plugin
export default {"button":"MyButton_button__hnBco","primaryBlack":"MyButton_primaryBlack__lT6iJ","medium":"MyButton_medium__zECr-","large":"MyButton_large__9ogaL","hero":"MyButton_hero__VZxod"};